'use strict';

exports.molfileToJme = require('./molfileToJme');
exports.jmeToMolfile = require('./jmeToMolfile');



/*****************
 ** WEBPACK FOOTER
 ** ./src/index.js
 ** module id = 0
 ** module chunks = 0
 **/